import { Translate2 } from 'common'
import { IdValueGeneric } from 'interfaces'
import React from 'react'

export interface TablePickerProps {
  label?: string
  parentRef: React.RefObject<HTMLElement>
  isActive: boolean
  onSelectItem: (selection: VehicleDropdownOnChangeProps) => void
  onCancel: () => void
  columns: Array<TableColumn>
  selectedOption: IdValueGeneric<number, string>
  enableSearch?: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Bulk disabling. Fix if possible.
  tableRef: any
}

export interface VehicleDropdownProps {
  label: string
  selection: IdValueGeneric<number, string>
  active: boolean
  disabled: boolean
  onClick: () => void
  onChange: (selection: VehicleDropdownOnChangeProps) => void
  onCancel?: () => void
  options: Array<TableColumn>
  enableSearch?: boolean
  disableSearch?: boolean
}

export interface VehicleDropdownOnChangeProps {
  selection: IdValueGeneric<number, string>
  selectionType?: IdValueGeneric<number, string>
}

export interface TableColumn {
  id?: number
  header?: string
  options?: Array<TableColumnOption>
}

// typeId and typeName will save the id and header of the TableColumn when we flatten the table
export interface TableColumnOption {
  id: number
  value: string
  typeId?: number
  typeName?: string
  regionIds?: number[]
}

export interface ServiceIntervalsDrawerProps {
  onClose: () => void
  open: boolean
  showEditFitmentConditions: boolean
  handleEditFitmentConditions: () => void
}

export const defaultServiceIntervalType = [
  {
    id: 1,
    value: Translate2('normal'),
  },
  {
    id: 2,
    value: Translate2('severe'),
  },
]
